export const REPLY_RAIL_ACTIONS = Object.freeze({
  OPEN_CHILDREN: "open-children",
  REPLY: "reply",
});

/**
 * Keeps the reply rail's one interaction rule consistent across cards and drawers.
 */
export function getReplyRailAction(childCount) {
  const normalizedCount = Number(childCount);
  return Number.isFinite(normalizedCount) && normalizedCount > 0
    ? REPLY_RAIL_ACTIONS.OPEN_CHILDREN
    : REPLY_RAIL_ACTIONS.REPLY;
}
